import React from 'react';

import {Stack, Divider, Typography} from 'views/components';
import {Translate} from 'views/module';

import NextStepsSection from './Sections/NextStepsSection';
import CareTeamSection from './Sections/CareTeamSection';
import InformationalSection from './Sections/InformationalSection';

const DashboardCaregiverSearch = () => {
  const sections = [
    {
      component: <NextStepsSection />,
    },
    {
      component: <CareTeamSection />,
    },
    {
      component: <InformationalSection />,
    },
  ];

  return (
    <Stack spacing={4}>
      <Stack spacing={1}>
        <Typography
          variant='h4'
        >
          <Translate expression={'dashboard.title'} />
        </Typography>
        <Typography
          variant='subtitle1'
        >
          <Translate expression={'dashboard.subtitle'} />
        </Typography>
      </Stack>

      {sections.map((section, idx) => (
        <React.Fragment key={idx}>
          {section.component}
          {idx !== sections.length - 1 && <Divider />}
        </React.Fragment>
      ))}
    </Stack>
  );
};

export default DashboardCaregiverSearch;
